<template>
  <div :class="applySideBarDockClasses()">
    <div class="sidebar-toggler" @click="toggleSideBar">
      <svg
        id="Capa_1"
        :class="
          isDocked ? 'svg-arrow-icon-not-docked' : 'svg-arrow-icon-docked'
        "
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        x="0px"
        y="0px"
        width="960px"
        height="560px"
        viewBox="0 0 960 560"
        enable-background="new 0 0 960 560"
        xml:space="preserve"
      >
        <g id="Rounded_Rectangle_33_copy_4_1_">
          <path
            d="M480,344.181L268.869,131.889c-15.756-15.859-41.3-15.859-57.054,0c-15.754,15.857-15.754,41.57,0,57.431l237.632,238.937   c8.395,8.451,19.562,12.254,30.553,11.698c10.993,0.556,22.159-3.247,30.555-11.698l237.631-238.937   c15.756-15.86,15.756-41.571,0-57.431s-41.299-15.859-57.051,0L480,344.181z"
          />
        </g>
      </svg>
    </div>
    <div>
      <div class="navlinks-container">
        <div class="edyst-admin-title">
          <span style="color:#24a8fb">Edyst</span> Admin
        </div>
        <button
          v-if="isUserLoggedIn()"
          class="logout-button"
          @click="logOutUser"
        >
          Logout
        </button>
        <small class="text-center block text-green-dark my-1"
          >Hit <code class="bg-grey-light p-1 rounded-sm">/</code> for onscreen
          navigation menu.</small
        >
        <router-link class="navbar-item" :to="goToPage('')">Home</router-link>
        <!--  -->
        <div class="navbar-item-title">Marketing</div>
        <router-link
          class="navbar-item"
          :to="goToPage('update-youtube-session')"
          >LP Youtube Sessions</router-link
        >
        <router-link
          class="navbar-item"
          :to="goToPage('update-testimonial-carousel')"
          >LP Carousel</router-link
        >
        <router-link class="navbar-item" :to="goToPage('join-links-list')"
          >Join Links</router-link
        >
        <router-link class="navbar-item" :to="goToPage('job-listing-list')"
          >Job Listings</router-link
        >
        <router-link
          v-if="adminType === 'marketing'"
          class="navbar-item"
          :to="goToPage('notification')"
          >Campaigns and Notifications</router-link
        >
        <!--  -->
        <div class="navbar-item-title">Community Manager</div>
        <router-link class="navbar-item" :to="goToPage('manage-students')"
          >Manage Students</router-link
        >
        <router-link class="navbar-item" :to="goToPage('college-cleanup')"
          >College cleanup</router-link
        >
        <!--  -->
        <div v-if="adminType !== 'marketing'">
          <div class="navbar-item-title">Web Questions Menu</div>
          <router-link class="navbar-item" :to="goToPage('web-questions')"
            >Web Questions</router-link
          >
          <router-link class="navbar-item" :to="goToPage('project-questions')"
            >Project Questions</router-link
          >
          <router-link class="navbar-item" :to="goToPage('project-submissions')"
            >Project Submissions</router-link
          >
          <div class="navbar-item-title">Questions</div>

          <router-link class="navbar-item" :to="goToPage('company')"
            >Company</router-link
          >

          <router-link class="navbar-item" :to="goToPage('questionbank-tags')"
            >QuestionBank Tags</router-link
          >
          <router-link class="navbar-item" :to="goToPage('reading')"
            >Reading</router-link
          >
          <router-link
            class="navbar-item"
            :to="goToPage('mcq?page=1&per_page=20')"
            >MCQ Editor</router-link
          >
          <router-link
            class="navbar-item"
            :to="goToPage('mcq-stitched?page=1&per_page=20')"
            >MCQ Stitched</router-link
          >
          <router-link class="navbar-item" :to="goToPage('video')"
            >Videos</router-link
          >
          <router-link class="navbar-item" :to="goToPage('coding')"
            >Coding</router-link
          >
          <router-link class="navbar-item" :to="goToPage('hint')"
            >Hint</router-link
          >
          <router-link class="navbar-item" :to="goToPage('editorial')"
            >Editorial</router-link
          >
          <router-link class="navbar-item" :to="goToPage('blockly')"
            >Blockly</router-link
          >
          <router-link class="navbar-item" :to="goToPage('interview')"
            >Interview Question</router-link
          >
          <router-link class="navbar-item" :to="goToPage('ghostcms')"
            >Ghost CMS</router-link
          >

          <div class="divider-navbar-edyst" />
          <!--  -->
          <div class="navbar-item-title">Course Builders</div>
          <router-link class="navbar-item" :to="goToPage('courses')"
            >Courses</router-link
          >
          <router-link class="navbar-item" :to="goToPage('tags')"
            >Tags</router-link
          >
          <router-link class="navbar-item" :to="goToPage('preassessments')"
            >Preassessments</router-link
          >
          <router-link class="navbar-item" :to="goToPage('assessmentlist')"
            >Assessments</router-link
          >
          <router-link class="navbar-item" :to="goToPage('cohort')"
            >Cohorts</router-link
          >
          <router-link class="navbar-item" :to="goToPage('question-bank/cohort')"
            >Question Bank Cohorts</router-link
          >
          <router-link class="navbar-item" :to="goToPage('file')"
            >File Upload</router-link
          >
          <router-link class="navbar-item" :to="goToPage('game')"
            >Game</router-link
          >
          <router-link class="navbar-item" :to="goToPage('event-list/contest')"
            >Events - Contest</router-link
          >
          <router-link
            class="navbar-item"
            :to="goToPage('event-list/liveclass')"
            >Events - Liveclass</router-link
          >
          <router-link class="navbar-item" :to="goToPage('events/bulk-upload')"
            >Liveclass Bulk Upload</router-link
          >
          <router-link class="navbar-item" :to="goToPage('subscription-plans')"
            >Subscription Plans</router-link
          >
          <div class="divider-navbar-edyst" />
          <!--  -->
          <div class="navbar-item-title">Survey Questions</div>
          <router-link class="navbar-item" :to="goToPage('survey_questions')">
            Survey Questions
          </router-link>
          <!--  -->
          <div class="navbar-item-title">Misc.</div>
          <router-link class="navbar-item" :to="goToPage('notification')"
            >Campaigns and Notifications</router-link
          >
          <router-link class="navbar-item" :to="goToPage('user')"
            >User Menu</router-link
          >
          <router-link class="navbar-item" :to="goToPage('certificates')"
            >Certificates</router-link
          >
          <router-link
            class="navbar-item"
            :to="goToPage('manage-reports-dashboards')"
            >Reports Dashboard Menu</router-link
          >
          <router-link class="navbar-item" :to="goToPage('manage-roles')"
            >Manage Roles</router-link
          >
          <router-link class="navbar-item" :to="goToPage('manage-admin-roles')"
            >Manage Admin Roles</router-link
          >
          <router-link class="navbar-item" :to="goToPage('custom-forms')"
            >Custom Forms</router-link
          >
          <router-link class="navbar-item" :to="goToPage('assessments')"
            >Assessments Recordings</router-link
          >
          <router-link class="navbar-item" :to="goToPage('interview-videos')"
            >Interview Videos</router-link
          >
          <router-link class="navbar-item" :to="goToPage('language')"
            >Languages</router-link
          >
          <router-link class="navbar-item" :to="goToPage('institution')"
            >Institutions</router-link
          >
          <router-link
            class="navbar-item"
            :to="goToPage('engineering-branches')"
            >Engineering Branches</router-link
          >
          <router-link class="navbar-item" :to="goToPage('coupons')"
            >Coupons</router-link
          >
          <router-link class="navbar-item" :to="goToPage('reports')"
            >Reports</router-link
          >
          <router-link class="navbar-item" :to="goToPage('youtube-reports')"
            >Edit User College/Branches</router-link
          >
          <router-link class="navbar-item" :to="goToPage('referrals')"
            >External Referrals</router-link
          >
        </div>
        <div class="divider-navbar-edyst mb-12" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDocked: true,
      previousActiveElement: undefined,
    }
  },
  computed: {
    adminType() {
      return localStorage.role
    },
  },
  watch: {
    $route() {
      this.hideSideBar()
    },
  },
  mounted() {
    document.onkeydown = (e) => {
      if (e.key === "m" && e.ctrlKey) {
        const toggler = document.querySelector(".sidebar-toggler")
        if (toggler) {
          toggler.click()
        }
        setTimeout(() => {
          if (!this.isDocked) {
            this.previousActiveElement = document.activeElement
            const navbarItem = document.querySelector(".navbar-item")
            if (navbarItem) navbarItem.focus()
          } else if (this.previousActiveElement) {
            this.previousActiveElement.focus()
          } else {
            document.querySelector(".container").focus()
          }
        }, 200)
      }
    }
  },
  methods: {
    logOutUser() {
      localStorage.token = undefined
      localStorage.userName = undefined
      if (this.$route.name === "Login") {
        window.location.reload()
      } else {
        this.$router.push("/")
        this.$forceUpdate()
      }
    },
    isUserLoggedIn() {
      if (localStorage.token === undefined) {
        return false
      }
      if (localStorage.token.length < 16) {
        return false
      }
      return true
    },
    goToPage(pageURL) {
      if (pageURL === "college-cleanup") {
        return `/${pageURL}?page=1&per_page=15&sort_by=name%26order%3Dascending`
      }
      if (pageURL === "project-submissions") {
        return `/${pageURL}?review_state=pending&sort_by=-updated_on&page=1&per_page=20`
      }
      return `/${pageURL}`
    },
    hideSideBar() {
      this.isDocked = true
    },
    toggleSideBar() {
      this.isDocked = !this.isDocked
    },

    applySideBarDockClasses() {
      const classes = ["sidebarnav"]
      if (this.isDocked) {
        classes.push("sidebar-is-docked")
      } else {
        classes.push("sidebar-is-not-docked")
      }

      return classes.join(" ")
    },
  },
}
</script>

<style>
.logout-button {
  box-sizing: border-box;
  width: 12rem;
  margin: 0.5rem 1rem;
  padding: 5px;
  color: white;
  background: red;
}

.logout-button:hover {
  filter: brightness(0.9);
  background: red;
}

.navlinks-container {
  overflow-y: scroll;
  height: 100vh;
}
.divider-navbar-edyst {
  width: 100%;
  margin-bottom: 4px;
  border-bottom: 1px solid #bde5ff;
}
.edyst-admin-title {
  padding: 20px;
  font-family: "Gudea", sans-serif;
  font-weight: 700;
  text-align: center;
}
.navbar-item-title {
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 12px;
  color: #868686;
  font-family: "Gudea", sans-serif;
  font-size: 0.8em;
  font-weight: 700;
  cursor: default;
}
.navbar-item {
  display: block;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 20px;
  border: 1px solid white;
  font-family: "Gudea", sans-serif;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
}
.navbar-item:hover {
  border: 1px solid white;
  color: white;
  background-color: #24a8fb;
}

a.navbar-item {
  color: #424242;
}
a.navbar-item:focus {
  color: white;
  background: #24a8fb;
}
.svg-arrow-icon-not-docked {
  display: block;
  width: 100%;
  height: 100%;
  transition: all 0.5s;
  transform: rotate(-90deg);
}
.svg-arrow-icon-docked {
  display: block;
  width: 100%;
  height: 100%;
  transition: all 0.5s;
  transform: rotate(90deg);
}
.sidebar-is-docked {
  left: -250px;
}
.sidebar-is-not-docked {
  left: -1px;
}
.sidebarnav {
  position: fixed;
  z-index: 1000;
  top: -1px;
  width: 250px;
  height: 100vh;
  background-color: white;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.4);
  transition: 0.3s;
  /* overflow-y: scroll; */
}
.sidebar-toggler {
  position: absolute;
  top: 0px;
  right: -49px;
  width: 48px;
  height: 48px;
}
/* SCROLLBAR CSS */
*::-webkit-scrollbar {
  width: 10px;
}

*::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

*::-webkit-scrollbar-thumb {
  border-radius: 100px;
  outline: 1px solid slategrey;
  background-color: grey;
}
</style>
